import getDefaultTextTransformByRole from '../getDefaultTextTransformByRole';
import transformText from '../transformText';
import { LAYER_TYPES, LAYER_ROLES } from '../layerTypes';
import { TEXT_TRANSFORM } from '../transformText/constants';

/**
 * Determines that text contains uppercase letters ignoring the first letter in the word.
 * @param  {String} text Brand name or Slogan
 * @return {Boolean}
 */
const containsNotFirstUppercaseLetters = (text = '') =>
    text.split(' ').some((substr) => {
        const matched = substr.substring(1).match(/[A-Z]/g);
        return matched && !!matched.length;
    });

/**
 * Determines that text contains only uppercase letters.
 * @param  {String} text Brand name or Slogan
 * @return {Boolean}
 */
const isUppercasedText = (text = '') => !(text.match(/[a-z]/g) || []).length;

const setVariationTextFields = ({ variation, brandName, slogan }) => ({
    ...variation,
    roots: variation.roots.map((root) => {
        const { layerType, layerRole, layers = [] } = root;
        const allowedLayerType = layerType === LAYER_TYPES.TEXT;
        const allowedLayerRole = [LAYER_ROLES.BRAND_NAME, LAYER_ROLES.SLOGAN].includes(layerRole);

        if (!allowedLayerType || !allowedLayerRole) {
            return root;
        }

        const text = layerRole === LAYER_ROLES.BRAND_NAME ? brandName : slogan;
        const [layer] = layers;

        let { textTransform = getDefaultTextTransformByRole(layerRole) } = layer.style;

        if (!isUppercasedText(text) && containsNotFirstUppercaseLetters(text)) {
            textTransform = TEXT_TRANSFORM.NONE;
        }

        const style = {
            ...layer.style,
            textTransform,
        };

        return {
            ...root,
            layers: [
                {
                    ...layer,
                    style,
                    children: transformText(text, textTransform),
                },
            ],
        };
    }),
});

export default setVariationTextFields;
